<div class="main-content">
  <mat-toolbar class="bg-white mat-toolbar-override">
    <button
      mat-icon-button
      (click)="back()"
      id="upload_reasons_management_add_edit_back_btn"
    >
      <mat-icon color="primary"> keyboard_backspace </mat-icon>
    </button>
  </mat-toolbar>

  <div class="header">
    <h1>
      {{
        (!isEditMode
          ? "upload_reasons_management_add_edit_add_header"
          : "upload_reasons_management_add_edit_edit_header"
        ) | translate
      }}
    </h1>
  </div>
  <label class="details">
    {{ "upload_reasons_management_add_edit_details" | translate }}
  </label>
  <form [formGroup]="reasonForm">
    <div fxLayout="row">
      <div fxLayout="column" fxFlex="100%">
        <div class="input-field">
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label class="color-city-neutral">
              {{
                "upload_reasons_management_add_edit_form_lbl_description"
                  | translate
              }}
            </mat-label>
            <input
              matInput
              placeholder="{{
                'upload_reasons_management_add_edit_form_lbl_description'
                  | translate
              }}"
              formControlName="description"
              required
              id="input_description"
            />
            @if (hasError(reasonForm, 'description')) {
            <mat-error>
              {{
                "upload_reasons_management_add_edit_error_upload_reason_description_validator"
                  | translate
              }}
            </mat-error>
            }
          </mat-form-field>
        </div>

        @for (lang of languages; track lang) {
        <div class="input-field">
          <mat-form-field appearance="fill" fxFlex="100">
            <mat-label class="color-city-neutral">
              {{
                "upload_reasons_management_add_edit_form_lbl_description"
                  | translate
              }}
              {{ lang.description }}
            </mat-label>
            <input
              matInput
              placeholder="{{
                'upload_reasons_management_add_edit_form_lbl_description'
                  | translate
              }}"
              formControlName="{{ lang.code.replace('-', '_') }}"
              id="input_description_{{ lang.code.replace('-', '_') }}"
            />
            @if (hasError(reasonForm, lang.code.replace('-', '_'))) {
            <mat-error>
              {{
                "upload_reasons_management_add_edit_error_upload_reason_language_validator"
                  | translate
              }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }

        <div class="input-field">
          <mat-checkbox class="color-city-blue" formControlName="isRequired">
            {{
              "upload_reasons_management_add_edit_form_lbl_isrequired"
                | translate
            }}
          </mat-checkbox>
        </div>

        <div class="input-field">
          <mat-checkbox class="color-city-blue" formControlName="isActive">
            {{
              "upload_reasons_management_add_edit_form_lbl_isactive" | translate
            }}
          </mat-checkbox>
        </div>

        <div
          class="button-grp"
          fxLayout="column"
          fxFlex="100%"
          fxLayoutGap="1em"
        >
          <button
            id="btn_save"
            mat-raised-button
            (click)="saveOnClick()"
            type="submit"
            [disabled]="disableSaveOnClick()"
          >
            {{ "upload_reasons_management_add_edit_save_btn" | translate }}
          </button>
          <button id="btn_cancel" mat-raised-button (click)="closeOnClick()">
            {{ "upload_reasons_management_add_edit_close_btn" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
